import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { appInsights } from './AppInsightsManager';

const trackAsyncAPIsFailure = (message: string, detail: string) => {
  trackException(`API call failed: ${message}, cause: ${detail}`);
};

const trackDexiDBFailure = (message: string, detail: string) => {
  trackException(`DexieDb failed: ${message}, cause: ${detail}`);
};

const trackException = (message: string, options?: ErrorOptions) => {
  appInsights.trackException({ error: new Error(message, options), severityLevel: SeverityLevel.Error });
};

const trackTrace = (message: string) => {
  appInsights.trackTrace({ message, severityLevel: SeverityLevel.Information });
};

const trackEvent = (name: string) => {
  appInsights.trackEvent({ name });
};

export const appInsightsTracker = {
  trackAsyncAPIsFailure,
  trackDexiDBFailure,
  trackException,
  trackTrace,
  trackEvent,
};
